export default __webpack_public_path__ + "3b5b70046de88ede53a1f70cd77f21d2.svg";